import { createFileRoute } from "@tanstack/react-router";
import { SmsUsagePage } from "@/features/sms/usage-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/sms/zuzycie")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(context.queryClient, "sidebar.sms.zuzycie", location.pathname);
	},
	component: SmsUsagePage,
});
